import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RecipientOtpApiService } from '../../shared/services/auth/recipient-otp-api.service';
import { AuthStateService } from './auth-state.service';

export const protectedOnlyGuard: CanActivateFn = (_, state: RouterStateSnapshot) => {
    const recipientOtpApiService = inject(RecipientOtpApiService);
    const authStateService = inject(AuthStateService);

    return recipientOtpApiService.checkAuth().pipe(
        tap((isAuthenticated) => {
            authStateService.setOnProtectedRoute(isAuthenticated);
        }),
        catchError(() => {
            authStateService.setOnProtectedRoute(false);
            return of(false);
        }),
        map((isAuthenticated) => {
            return isAuthenticated;
        })
    );
};
